import { render, staticRenderFns } from "./VascularPhenomenaSection.vue?vue&type=template&id=f71ebcd4&"
import script from "./VascularPhenomenaSection.vue?vue&type=script&lang=js&"
export * from "./VascularPhenomenaSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports